import styled from 'styled-components'

import { Flex } from '../'

const FullWidth = styled(Flex)`
  @media screen and (min-width: 96em) {
    margin-left: ${({ left, right, center }) =>
      center
        ? //  note the 600px creates an upper limit so it doesn't grow too big on large screens
          // this equates to at most -300px margins
          // so given the container's max width is 96em (1200px) - 50px padding, the full width will be at most 1775px (1200px + 2*300px + 2*25px)
          'calc(25% - min(25vw, 600px))'
        : left || (!left && !right)
        ? 'calc(50% - 50vw)'
        : 'auto'};
    margin-right: ${({ left, right, center }) =>
      center
        ? 'calc(25% - min(25vw, 600px))'
        : right || (!left && !right)
        ? 'calc(50% - 50vw)'
        : 'auto'};
  }

  width: auto;
  max-width: initial;
  position: ${({ absolute }) => (absolute ? 'absolute' : 'static')};
`
FullWidth.displayName = 'FullWidth'

export default FullWidth
